module.exports = __webpack_public_path__ + "img/meter-bolt.2b03f889.svg";